import { Expose, Type } from 'class-transformer'
import { IsDefined, IsNumber, ValidateNested } from 'class-validator'
import { Warranty } from '../../entity'

export class WarrantiesDTO {
    @Expose()
    @ValidateNested()
    @Type(() => Warranty)
    data!: Warranty[]

    @Expose()
    @IsDefined()
    @IsNumber()
    page!: number

    @Expose()
    @IsDefined()
    @IsNumber()
    pageSize!: number

    @Expose()
    @IsDefined()
    @IsNumber()
    count!: number
}
